import Icon from '@components/Icon/Icon';

import styles from '../Field.module.scss';

interface AddressContentProps {
  address: string;
  label?: string;
  size?: 'regular' | 'small' | 'extra-small';
}

const AddressContent: React.FC<React.PropsWithChildren<AddressContentProps>> = ({ address, label, size }) => {
  return (
    <div className={styles['card-field']} data-size={size}>
      <div className={styles['card-item-icon-circle']} data-size={size}>
        <Icon type="address" className={styles['field-icon']} data-size={size} />
      </div>
      <div className={styles['field-data']}>
        <div className={styles['field-data-value']} data-type="address">
          {address}
        </div>
        {label && <div className={styles['field-data-label']}>{label}</div>}
        {!label && !address && <div className={styles['field-data-value-placeholder']}>Address</div>}
      </div>
    </div>
  );
};

export default AddressContent;
